// extracted by mini-css-extract-plugin
module.exports = {"header":"_nBM4ZaU","highlight":"_19kka6P"};